import { ISSUE_TYPE } from "@/types/enum/general";

const placeholderDE = {
    search: 'Suche',
    selectSize: 'Größe selektieren',
    selectVariant: 'Variante selektieren',
    location: {
        name: 'Name deiner Location',
        type: 'Art der Location',
        zip: 'Postleitzahl',
        ownZip: 'Postleitzahl Ihrer eigenen Location',
        city: 'Ort',
        street: 'Straße',
        streetNumber: 'Nr.',
        phone: 'Telefonnummer',
        internationalPhone: 'Internationale Telefonnummer',
        deliverer: '@:object.deliverer auswählen',
        customerNumber: '@:label.customerNumber eintragen'
    },
    email: 'Email',
    newEmail: 'Neue Email',
    oldPassword: 'Altes @:input.password',
    password: '@:input.password',
    passwordRepeat: '@:input.password wiederholen',
    sendMessageDeliverer: 'Sende eine Nachricht an {deliverer} ...',
    inviteCode: 'Einladungscode eingeben',
    firstName: '@:label.firstName',
    lastName: '@:label.lastName',
    name: 'Name',
    phone: '@:placeholder.location.phone',
    street: 'Straße',
    zip: 'PLZ',
    city: 'Ort',
    alphabetic: 'Alphabetisch',
    customerNumber: 'Kundennummer',
    customerNumberPlus: 'Kundennummer/Absatzstättennummer',
    quickstart: 'Quickstart Code',
    paymentMethod: 'Zahlungsart',
    pickupMethod: 'Location',
    deliveryDate: 'Lieferdatum',
    emailOrPhone: '@:placeholder.email' /*oder Telefonnummer*/,
    code: 'Einladungscode',
    packaging: 'Packungsgröße',
    searchOrAdd: 'Kategorie suchen oder hinzufügen',
    tagName: 'Kategoriename',
    pickupLocation: 'Abholung in',
    pickupDate: 'Abholzeitpunkt',
    quantity: 'Menge',
    eancode: 'EAN-Code',
    customSupplierType: 'Lieferantentyp',
    issueType: 'Feedbackart',
    title: 'Titel',
    [ISSUE_TYPE.BUG]: {
        issue: 'Was ist das Problem?',
        place: 'Wo tritt das Problem auf?',
        expectation: 'Welches Verhalten würden Sie statt dem derzeitigen Verhalten erwarten?',
        steps: 'Welche Schritte wurden ausgeführt bis der Bug aufgetreten ist? / Wie lässt sich der Bug reproduzieren?',
    },
    [ISSUE_TYPE.FEATURE]: {
        expectation: 'Was für eine Funktion wünschst du dir zusätzlich?',
        place: 'Wo fehlt dir die gewünschte Funktion?'
    },
    select: 'Auswählen',
    contactWay: 'Wie dürfen wir dich für Fragen und Updates kontaktieren?'
}

export default placeholderDE
